export const vehiclesInventoryScreens = {
  'main': {
    'name': 'MainScreen',
    'description': 'Administración de inventario',
  },
  'vehiclesByLineTable': {
    'name': 'VehiclesByLineScreen',
    'description': 'Administración de inventario - Resumen por modelo - Líneas',
  },
};
